import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class SponsorFirmaListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "SponsorFirmaListe";
    super(baseUrl);
  }


  getSponsorFirmaListe( sponsorFirmaKodu?: number){
    var request= new SponsorFirmaListeRequest( sponsorFirmaKodu);
    
    return this.get("",request);
  }

}


export default new SponsorFirmaListeAPI();
class SponsorFirmaListeRequest {
  public sponsorFirmaKodu?: number;

 
  constructor(sponsorFirmaKodu?: number) {
   
      this.sponsorFirmaKodu = sponsorFirmaKodu;

      
  }
}
export { SponsorFirmaListeRequest };